import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

interface TabOptionInterface {
  id: any;
  label: string;
  ariaControls: string;
  disabled: boolean;
}

@Component
class EdTabsHeaderMenu extends Vue {
  @Prop({ required: true }) readonly tabs!: TabOptionInterface[];
  @Prop({ required: true }) readonly currentTab!: any;
  @Prop({ type: Boolean, default: false }) readonly isOutlined!: boolean;
  @Prop({ required: false }) readonly classTabs!: {};
  @Prop({ required: false }) readonly backgroundColor!: String;
  @Prop({ required: false, default: 'var(--ed-color-light)' }) readonly backgroundColorActiveOutline!: String;
  @Prop({ required: false, default: () => ({}) }) readonly classChildTabs!: Record<string, boolean>;

  @Emit('tabChange')
  tabChange(tabId: string | number): string | number {
    return tabId;
  }

  get loadScssVar() {
    return {
      '--ed-display': this.isOutlined? 'inherit' : 'none',
      '--ed-letter-spacing': this.isOutlined? '1.3px' : 'initial' ,
      '--ed-font-size': this.isOutlined? '0.875rem' : '15px',
      '--ed-background-color': this.backgroundColor,
      '--ed-background-color-active-outline': this.backgroundColorActiveOutline,
    };
  }
}

export default Vue.component('ed-tabs-header-menu', EdTabsHeaderMenu)